import React from 'react';
import { Form, Select } from 'antd';
import Label from '@/components/Label/Label';

interface Option {
	value: string;
	label: string;
}

interface props {
	name: string;
	label: string;
	placeholder?: string;
	options: Option[];
}

const FormSelect: React.FC<props> = ({ name, label, placeholder, options }) => {
	return (
		<Form.Item name={name} label={<Label text={label} />}>
			<Select options={options} placeholder={placeholder} />
		</Form.Item>
	);
};

export default FormSelect;
